<template>
  <div class="text-center">
    <slot name="value">
      <div class="d-inline-flex justify-content-center mb-2 align-items-end">
        <LoadingIndicatorComponent v-if="isLoading" inline class="me-2" />
        <h3 v-else class="mx-2 mb-0 fs-6">{{ value }}</h3>
        <div class="fs-9 text-muted">{{ unit }}</div>
      </div>
    </slot>
    <h4 class="mb-3 fs-8 font-serif">{{ title }}</h4>
    <div class="d-inline-flex align-items-center justify-content-center">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import LoadingIndicatorComponent from "@/components/common/LoadingIndicatorComponent.vue";

/**
 * One headline figure on a dashboard header — value, unit and caption — with the buttons it
 * leads to in the default slot. The `value` slot replaces the value and unit for a figure of
 * its own shape.
 */
defineProps<{
  /** Unused when the `value` slot is filled. */
  value?: string;
  unit?: string;
  title: string;
  isLoading?: boolean;
}>();
</script>
